import { useNavigate } from "react-router-dom";
import { ExpeditionBanner } from "../ExpeditionBanner/ExpeditionBanner";
import { ExpeditionInfo } from "../ExpeditionInfo/ExpeditionInfo";
import { ExpeditionPrizes } from "../ExpeditionsPrizes/ExpeditionPrizes";
import styles from "./ExpeditionDetails.module.css";
import { useCallback, useEffect, useState } from "react";
import { Expedition } from "../../types";
import { Loader } from "../../../../Components/Loader/Loader";
import useApplicationSettings from "../../../../Store/ApplicationSettings";
import { getExpeditionInfo } from "../../../../Services/Requests";
import { useNotificationStore } from "../../../../Store/NotificationStore";

const ExpeditionDetails: React.FC = () => {
	const [expedition, setExpedition] = useState<Expedition | null>(null);
	const navigate = useNavigate();
	const tg = window.Telegram.WebApp;
	const { setShowMenubar } = useApplicationSettings(state => ({
		setShowMenubar: state.setShowMenubar,
	}));

	const setNotification = useNotificationStore(state => state.setNotification);

	useEffect(() => {
		const fetchExpedition = async () => {
			try {
				const data = await getExpeditionInfo(1);
				setExpedition(data);
			} catch (e) {
				setNotification({
					type: "Error",
					message:
						"Произошла ошибка при получении экспедиции. Попробуйте позже",
				});
				console.log("Проблема с запросом экспедиции", e);
			}
		};
		fetchExpedition();
	}, []);

	console.log("expedition", expedition);

	const handleBack = useCallback(() => {
		navigate("/");
	}, [navigate]);

	useEffect(() => {
		setShowMenubar(false);
		tg.BackButton.show();
		tg.BackButton.onClick(handleBack);
		return () => {
			tg.BackButton.offClick(handleBack);
		};
	}, [handleBack, tg.BackButton, setShowMenubar]);

	return (
		<div className={styles.container}>
			{!expedition ? (
				<Loader size='medium' />
			) : (
				<>
					<ExpeditionBanner expedition={expedition} />

					<ExpeditionInfo
						expedition={expedition}
						setExpedition={setExpedition}
					/>

					<ExpeditionPrizes prizes={expedition.prizes} />
				</>
			)}
		</div>
	);
};

export { ExpeditionDetails };
